import type { PropsWithChildren } from 'react';

import { twJoin, twMerge } from 'tailwind-merge';

export type LinkProps = PropsWithChildren<{
  className?: string;
  href: string;
}> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export function Link({ href, className, children, ...props }: LinkProps): React.ReactElement {
  const defaultClasses = twJoin(
    'underline text-primary-600 decoration-primary-600/50 decoration-1',
    'underline-offset-2 transition hover:text-primary-700 hover:decoration-primary-700',
  );

  const finalClasses = twMerge(defaultClasses, className);

  return (
    <a href={href} className={finalClasses} {...props}>
      {children}
    </a>
  );
}
